import React from 'react';
import { translate } from 'react-polyglot';

import ButtonGroup from '../ButtonGroup';
import Button from '../Button';
import Modal from '../Modal';

const DeleteModal = ({ onConfirm,
  onClose,
  viewport,
  t,
  count,
  books,
  shouldShowAudioDeleteWarning,
  userId,
  baseClassName,
  gaLabel,
  themeName,
  deleteQuestion,
  deleteSubInfo,
  deleteText,
  doNotDeleteText,
  isRtl }) => {

  const footer = (
    <ButtonGroup mergeTop mergeBottom={!viewport.large} mergeSides>
      <Button label={deleteText || t('DeleteModal.delete')} variant="primary" onClick={() => {
        onConfirm()
        onClose()
      }} />
      <Button label={doNotDeleteText || t('DeleteModal.dont-delete')} onClick={onClose} />
    </ButtonGroup>
  );

  return (
    <Modal footer={footer} onClose={onClose} isRtl={isRtl}>
      <h2 className={`${baseClassName}__delete-modal-title`}>{deleteQuestion || t('DeleteModal.title', count)}</h2>
      {
        deleteSubInfo
          ?
          <p>{deleteSubInfo}</p>
          :
          <p>{shouldShowAudioDeleteWarning ? t("DeleteModal.audio-delete-warning")
            : t("DeleteModal.warning")}</p>
      }

    </Modal>
  );
};

export default translate()(DeleteModal);



// WEBPACK FOOTER //
// ./src/components/Book/DeleteModal.jsx